export const BASE_URL = "https://aliveai-api-895617747900.us-west1.run.app";
// export const BASE_URL = "http://192.168.1.3:8000";
